/**
 * Catálogo mock Phase 2 (familias → subfamilias → artículos → marcas → modelos).
 * TODO: Sustituir por GET /digital-loan/families|sub-families|articles|branches|models.
 */

import { OTHER_OPTION, PRODUCT_CONDITIONS } from 'constants/digitalLoanPhase2';
import {
  buildAvailableVisitDates,
  DEFAULT_VISIT_TIME_SLOTS,
} from 'modules/digitalLoan/visitSchedule';

export const MOCK_FAMILIES = Object.freeze([
  { id: 'fam-sports', name: 'Artículos deportivos' },
  { id: 'fam-av', name: 'Audio y Video' },
  { id: 'fam-domestic', name: 'Domésticos Eléctricos' },
  { id: 'fam-gadgets', name: 'Gadgets' },
  { id: 'fam-tools', name: 'Herramientas' },
  { id: 'fam-home', name: 'Hogar' },
  { id: 'fam-machinery', name: 'Maquinaria' },
  { id: 'fam-vehicles', name: 'Vehículos' },
]);

const MOCK_SUB_FAMILIES_BY_FAMILY = Object.freeze({
  'fam-sports': [{ id: 'sf-sports-bikes', name: 'Bicicletas' }],
  'fam-av': [{ id: 'sf-av-cameras', name: 'Cámaras' }],
  'fam-domestic': [{ id: 'sf-dom-cleaning', name: 'Limpieza' }],
  'fam-gadgets': [{ id: 'sf-gad-drones', name: 'Drones' }],
  'fam-tools': [{ id: 'sf-tools-measure', name: 'Medición' }],
  'fam-home': [{ id: 'sf-home-tv', name: 'Pantallas' }],
  'fam-machinery': [{ id: 'sf-mach-sewing', name: 'Costura' }],
  'fam-vehicles': [{ id: 'sf-veh-moto', name: 'Motocicletas' }],
});

const MOCK_ARTICLES_BY_SUBFAMILY = Object.freeze({
  'sf-sports-bikes': [
    { id: 'art-bike', name: 'Bicicleta' },
    { id: 'art-bike-fold', name: 'Bicicleta desplegable' },
    { id: 'art-bike-e', name: 'Bicicleta eléctrica' },
    { id: 'art-bike-climb', name: 'Bicicleta escaladora' },
  ],
  'sf-av-cameras': [
    { id: 'art-camera', name: 'Cámara fotográfica' },
    { id: 'art-video', name: 'Cámara de video' },
  ],
  'sf-dom-cleaning': [
    { id: 'art-vacuum', name: 'Aspiradora' },
    { id: 'art-washer', name: 'Lavadora' },
  ],
  'sf-gad-drones': [{ id: 'art-drone', name: 'Drone' }],
  'sf-tools-measure': [{ id: 'art-scale', name: 'Báscula' }],
  'sf-home-tv': [{ id: 'art-tv', name: 'Televisor' }],
  'sf-mach-sewing': [{ id: 'art-sewing', name: 'Máquina de coser' }],
  'sf-veh-moto': [{ id: 'art-moto', name: 'Motocicleta' }],
});

const DEFAULT_BRANDS = Object.freeze([
  { id: 'brand-1', name: 'Marca #1' },
  { id: 'brand-2', name: 'Marca #2' },
  { id: 'brand-3', name: 'Marca #3' },
  { id: 'brand-4', name: 'Marca #4' },
  { id: 'brand-5', name: 'Marca #5' },
]);

const MOCK_BRANDS_BY_ARTICLE = Object.freeze({
  'art-bike': DEFAULT_BRANDS,
  'art-bike-fold': DEFAULT_BRANDS,
  'art-bike-e': DEFAULT_BRANDS,
  'art-bike-climb': DEFAULT_BRANDS,
  'art-camera': DEFAULT_BRANDS,
  'art-video': DEFAULT_BRANDS,
  'art-vacuum': [
    { id: 'brand-dyson', name: 'Dyson' },
    { id: 'brand-2', name: 'Marca #2' },
    { id: 'brand-3', name: 'Marca #3' },
  ],
  'art-washer': DEFAULT_BRANDS,
  'art-drone': DEFAULT_BRANDS,
  'art-scale': DEFAULT_BRANDS,
  'art-tv': DEFAULT_BRANDS,
  'art-sewing': DEFAULT_BRANDS,
  'art-moto': DEFAULT_BRANDS,
});

const MOCK_MODELS_BY_ARTICLE = Object.freeze({
  'art-bike': [
    { id: 'mod-bike-1', name: 'Modelo Deportivo' },
    { id: 'mod-bike-2', name: 'Modelo Urbano' },
  ],
  'art-vacuum': [
    { id: 'mod-dyson-v8', name: 'V8 Absolute' },
    { id: 'mod-dyson-v15', name: 'V15 Detect' },
  ],
  'art-tv': [
    { id: 'mod-tv-55', name: '55" 4K' },
    { id: 'mod-tv-65', name: '65" OLED' },
  ],
});

const DEFAULT_MODELS = Object.freeze([
  { id: 'mod-generic-1', name: 'Modelo estándar' },
  { id: 'mod-generic-2', name: 'Modelo premium' },
]);

export const MOCK_PRODUCT_CONDITION_OPTIONS = Object.freeze([
  { value: PRODUCT_CONDITIONS.EXCELLENT, labelKey: 'excellent' },
  { value: PRODUCT_CONDITIONS.GOOD, labelKey: 'good' },
  { value: PRODUCT_CONDITIONS.FAIR, labelKey: 'fair' },
]);

export function getMockFamiliesData() {
  return MOCK_FAMILIES.map((family) => ({ ...family }));
}

export function getMockSubFamiliesData(familyId) {
  const items = MOCK_SUB_FAMILIES_BY_FAMILY[familyId] || [];
  return items.map((item) => ({ ...item }));
}

export function getMockArticlesData(subFamilyId) {
  const items = MOCK_ARTICLES_BY_SUBFAMILY[subFamilyId] || [];
  return [...items.map((item) => ({ ...item })), { ...OTHER_OPTION }];
}

export function getMockBrandsData(articleId) {
  if (articleId === OTHER_OPTION.id) {
    return [{ ...OTHER_OPTION }];
  }
  const items = MOCK_BRANDS_BY_ARTICLE[articleId] || DEFAULT_BRANDS;
  return [...items.map((item) => ({ ...item })), { ...OTHER_OPTION }];
}

export function getMockModelsData(articleId) {
  if (articleId === OTHER_OPTION.id) {
    return [{ ...OTHER_OPTION }];
  }
  const items = MOCK_MODELS_BY_ARTICLE[articleId] || DEFAULT_MODELS;
  return [...items.map((item) => ({ ...item })), { ...OTHER_OPTION }];
}

export function buildMockPreOffer({
  amount,
  term,
  paymentFrequencyLabel,
  guaranteeName,
  rate,
}) {
  return {
    amount,
    term,
    paymentFrequency: paymentFrequencyLabel,
    paymentDay: '14 de cada mes',
    guaranteeName,
    guaranteeImage: null,
    rate: rate ?? null,
    availableVisitDates: buildAvailableVisitDates(new Date(), 5),
    availableVisitTimeSlots: [...DEFAULT_VISIT_TIME_SLOTS],
  };
}

export const createEmptyPhotos = () => ({
  front: null,
  angles: [],
  label: null,
  document: null,
});
